import { appData } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          APP下载
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12 max-w-[600px] mx-auto">
          国产91视频旗下视频APP下载，手机看视频移动端播放入口
        </p>

        <div className="max-w-[700px] mx-auto bg-background-50 border border-background-200/70 rounded-2xl p-6 md:p-10">
          <div className="flex flex-col md:flex-row items-center gap-8">
            <div className="flex-shrink-0">
              <div className="w-36 h-36 md:w-44 md:h-44 bg-background-100 border-2 border-primary-200/60 rounded-2xl p-3 flex items-center justify-center">
                <img
                  src={appData.qrImage}
                  alt="国产91视频APP下载二维码"
                  className="w-full h-full object-contain"
                />
              </div>
              <p className="text-xs text-foreground-400 text-center mt-3">扫码下载APP</p>
            </div>

            <div className="flex-1 text-center md:text-left">
              <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-3">
                {appData.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-5">
                {appData.description}
              </p>
              <div className="flex flex-wrap justify-center md:justify-start gap-2.5">
                {appData.badges.map((badge) => (
                  <span
                    key={badge.name}
                    className="inline-flex items-center gap-1.5 px-3.5 py-2 bg-secondary-100 text-secondary-800 rounded-lg text-xs font-medium whitespace-nowrap"
                  >
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className={`${badge.icon} text-xs`}></i>
                    </span>
                    {badge.name}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}